import { TabsContent } from "@radix-ui/react-tabs";
import { Switch } from "@/components/ui/switch";
import { Separator } from "@/components/ui/separator";
import { Label } from "@/components/ui/label";
import { Slider } from "@/components/ui/slider";
import { useDispatch, useSelector } from "react-redux";
import { playSound } from "@/lib/utils";
import { checkSound } from "@/assets";
import {
  toggleNotifications,
  toggleSales,
  setVolume,
  updateNotificationSettings,
} from "@/redux/slice/utility/soundNotificationSlice";
import { useRef } from "react";
import useAuth from "@/hooks/useAuth";

export default function Notification() {
  const dispatch = useDispatch();
  const { notificationsEnabled, sales, volume } = useSelector(
    (state) => state.utility.soundNotification
  );
  const { user } = useAuth();

  const debounceRef = useRef(null);

  const sendSettingsToBackend = (data) => {
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      dispatch(updateNotificationSettings(data));
    }, 500);
  };

  // Toggle Notifications
  const handleToggleNotifications = () => {
    const newValue = !notificationsEnabled;
    dispatch(toggleNotifications());

    if (newValue) playSound(checkSound);

    sendSettingsToBackend(
      {
        user_id: user?.id,
        early_access: newValue,
        sales,
        sound_level: Math.round(volume * 100),
      },
    );
  };

  // Toggle Sales Notifications
  const handleToggleSales = () => {
    const newValue = !sales;
    dispatch(toggleSales());
    sendSettingsToBackend(
      {
        user_id: user?.id,
        early_access: notificationsEnabled,
        sales: newValue,
        sound_level: Math.round(volume * 100),
      },
    );
  };

  //  Volume Change
  const handleVolumeChange = (val) => {
    dispatch(setVolume(val));

    if (notificationsEnabled) playSound(checkSound);

    sendSettingsToBackend({
      user_id: user?.id,
      early_access: notificationsEnabled,
      sales,
      sound_level: Math.round(val * 100),
    });
  };

  return (
    <TabsContent value="notification">
      <div className="py-6 mt-1 px-4 max-w-md w-full flex flex-col gap-6 text-cwhite">
        {/*  Enable Notifications */}
        <div className="flex items-center justify-between">
          <Label>Enable Notifications</Label>
          <Switch
            checked={notificationsEnabled}
            onCheckedChange={handleToggleNotifications}
          />
        </div>

        <Separator />

        {/*  Sales Notification */}
        <div className="flex items-center justify-between">
          <Label>Sales Notification</Label>
          <Switch checked={sales} onCheckedChange={handleToggleSales} />
        </div>

        <Separator />

        {/*  Volume Control */}
        <div className="flex flex-col gap-2">
          <Label>Volume: {Math.round(volume * 100)}%</Label>
          <Slider
            value={[volume]}
            max={1}
            step={0.01}
            onValueChange={(val) => handleVolumeChange(val[0])}
            disabled={!notificationsEnabled}
            className="w-full cursor-pointer"
          />
        </div>
      </div>
    </TabsContent>
  );
}
